import * as Yup from 'yup'

export const initialValues = {
  scenarioTitle: '',
  events: [{ id: Date.now(), title: '', text: '' }],
}

export const validationSchema = Yup.object().shape({
  scenarioTitle: Yup.string().required('Scenario title is required'),
  events: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string().required('Event title is required'),
        text: Yup.string().required('Event text is required'),
      })
    )
    .min(1, 'At least one event is required'),
})
